import { useEffect } from 'react';
import { Outlet, useMatch, useNavigate } from 'react-router-dom';
import { PermissionEnum, IconLoader, Tabs } from '@ui/src';
import { useAppSelector } from '@store';
import {
  useLazyGetTransactionsDictionariesQuery,
  useLazyGetTransactionsDictionariesWithoutGLQuery,
  useLazyGetTransactionsBaseCurrencyQuery,
  useLazyGetTransactionsCurrenciesQuery,
  useLazyGetTransactionsCountriesQuery,
} from '../../store/dictionaries/services';

import cn from './styles.module.css';

import ROUTES from '../../routes';

const CashCollection = (): React.JSX.Element => {
  const [getDictionaries] = useLazyGetTransactionsDictionariesQuery();
  const [getDictionariesWithoutGL] =
    useLazyGetTransactionsDictionariesWithoutGLQuery();
  const [getTransactionBaseCurrency] =
    useLazyGetTransactionsBaseCurrencyQuery();
  const [getTransactionCurrencies] = useLazyGetTransactionsCurrenciesQuery();
  const [getTransactionCountries] = useLazyGetTransactionsCountriesQuery();

  const match = useMatch(ROUTES.CASH_COLLECTION);

  const navigate = useNavigate();

  const {
    activePermissions,
    accounts,
    countries,
    currencies,
    baseCurrency,
    pspPartnerAccounts,
  } = useAppSelector((state) => state.transactionsDictionaries);

  useEffect(() => {
    if (
      activePermissions &&
      activePermissions.includes(PermissionEnum.TRANSACTIONS_INCOMING_LIST)
    ) {
      if (!accounts) {
        getDictionaries();
      }

      if (!pspPartnerAccounts) {
        getDictionariesWithoutGL();
      }

      if (!currencies) {
        getTransactionCurrencies();
      }

      if (!countries) {
        getTransactionCountries();
      }

      if (!baseCurrency) {
        getTransactionBaseCurrency();
      }
    }
  }, [
    activePermissions,
    baseCurrency,
    currencies,
    countries,
    pspPartnerAccounts,
    accounts,
  ]);

  useEffect(() => {
    if (match) {
      navigate(ROUTES.CASH_COLLECTION_LIST);
    }
  }, [match]);

  useEffect(() => {
    let title = 'Cash Collection';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.cashCollectionLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions) {
    content = (
      <div className={cn.cashCollection}>
        <div className={cn.cashCollectionTitle}>Cash collection</div>
        {activePermissions.includes(PermissionEnum.PAYMENTS_ORDERS_LIST) &&
          activePermissions?.includes(
            PermissionEnum.PAYMENTS_ORDERS_BENEFICIARIES_LIST,
          ) && (
            <div className={cn.cashCollectionTabsWrapper}>
              <Tabs
                tabs={[
                  {
                    name: 'Collection',
                    path: ROUTES.CASH_COLLECTION_LIST,
                  },
                  {
                    name: 'Orders',
                    path: ROUTES.CASH_COLLECTION_ORDERS,
                  },
                ]}
                itemClassName={cn.cashCollectionTab}
                enableRouting
              />
            </div>
          )}

        <Outlet />
      </div>
    );
  }

  return content;
};

export default CashCollection;
